'use client';

import { c as _c } from "react/compiler-runtime";
import type { ButtonHTMLAttributes } from 'react';
import { twMerge as tw } from 'tailwind-merge';
interface ButtonPrimaryProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  type?: 'button' | 'submit' | 'reset';
  className?: string;
  disabled?: boolean;
}
const ButtonPrimary = t0 => {
  const $ = _c(14);
  let children;
  let className;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      type: t1,
      className,
      disabled: t2,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
  } else {
    children = $[1];
    className = $[2];
    props = $[3];
    t1 = $[4];
    t2 = $[5];
  }
  const type = t1 === undefined ? "button" : t1;
  const disabled = t2 === undefined ? false : t2;
  let t3;
  if ($[6] !== className) {
    t3 = tw("inline-flex items-center justify-center bg-primary-dark dark:bg-primary-dark font-semibold py-3.5 px-7 rounded-xl transition-all duration-300 no-underline shadow-md relative overflow-hidden z-10 tracking-wide hover:bg-primary-dark dark:hover:bg-primary hover:-translate-y-1 hover:shadow-lg active:-translate-y-px text-shadow-gray-950 text-shadow-lg/70 *:drop-shadow-md *:drop-shadow-black/70", "text-white text-[#ffffff] font-bold", "border-2 border-primary dark:border-primary-light", className);
    $[6] = className;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== children || $[9] !== disabled || $[10] !== props || $[11] !== t3 || $[12] !== type) {
    t4 = <button type={type} className={t3} disabled={disabled} aria-disabled={disabled} {...props}>{children}</button>;
    $[8] = children;
    $[9] = disabled;
    $[10] = props;
    $[11] = t3;
    $[12] = type;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
};
export default ButtonPrimary;